/* eslint-disable promise/param-names */
import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT } from '../actions';
import axios from 'axios';

const state = { token: localStorage.getItem('moder-token') || '', status: '', hasLoadedOnce: false };

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
};

// const baseUrl = 'http://127.0.0.1:5000'
const baseUrl = '';

const actions = {
  [AUTH_REQUEST]: ({ commit, dispatch }, user) => new Promise((resolve, reject) => {
    commit(AUTH_REQUEST);
    axios.post('/api/v1/auth/login', {
      email: user.email,
      password: user.password,
    })
      .then((resp) => {
        localStorage.setItem('moder-token', resp.data.token_auth_string);
        commit(AUTH_SUCCESS, resp);
        resolve(resp);
      })
      .catch((err) => {
        commit(AUTH_ERROR, err);
        localStorage.removeItem('moder-token');
        reject(err.response);
      });
  }),
  [AUTH_LOGOUT]: ({ commit, dispatch }) => new Promise((resolve, reject) => {
    commit(AUTH_LOGOUT);
    localStorage.removeItem('moder-token');
    resolve();
  }),
};

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success';
    state.token = resp.data.token_auth_string;
    state.hasLoadedOnce = true;
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = '';
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js